import Vue from 'vue'
import VueRouter from 'vue-router'
import VueScrollTo from "vue-scrollto"


import { library } from '@fortawesome/fontawesome-svg-core'
import { faMeh, faSmile, faGrinHearts, faThumbsDown, faBullseye, faTrophy, faCrown } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VueNativeSock from 'vue-native-websocket'


require('./resources/styles/fonts.css');
require('./resources/styles/app.css');
require('./resources/styles/media.css');

import store from "./services/Store.js"
import App from './App.vue'
import HomeView from './components/views/HomeView.vue'
import GeneratingView from './components/modules/loading/GeneratingView.vue'
import LoadExistingView from './components/modules/loading/LoadExistingView.vue'
import ResultsView from './components/views/ResultsView.vue'
import AboutView from './components/views/AboutView'
import GenerateByKeywordView from "./components/modules/misc/GenerateByKeywordView";
import RechargeView from "./components/views/RechargeView";
import FAQsView from "./components/views/FAQsView";
import TOSView from "./components/views/TOSView";
import PrivacyView from "./components/views/PrivacyView";
import WallOfLoveView from "./components/views/WallOfLoveView";

Vue.config.productionTip = false;
Vue.use(VueRouter);
Vue.use(VueScrollTo);


library.add(faMeh, faSmile, faGrinHearts, faThumbsDown, faBullseye, faTrophy, faCrown);

Vue.component('font-awesome-icon', FontAwesomeIcon);

const routes = [
    {path: '/', component: HomeView, name: "home"},
    {path: '/generating', component: GeneratingView, name: "generating"},
    {path: '/loading/:slug', component: LoadExistingView, name: "loadExisting"},
    {path: '/results/:slug', component: ResultsView, name: "results"},
    {path: '/recharge/:slug', component: RechargeView, name: "recharge"},
    {path: '/recharge/:slug/:packageId', component: RechargeView, name: "rechargeWithPackage"},
    //When a suggestion is clicked:
    {path: '/keyword/:keyword', component: GenerateByKeywordView, name: "generateByKeyword"},
    {path: '/about', component: AboutView, name: "about"},
    {path: '/faq', component: FAQsView, name: "faq"},
    {path: '/tos', component: TOSView, name: "tos"},
    {path: '/privacy', component: PrivacyView, name: "privacy"},
    {path: '/wall', component: WallOfLoveView, name: "wall"},
    {path: '*', component: HomeView, name: "notFound"},
];

const router = new VueRouter({
    /*
    By changing mode to history, we'll use direct urls instead of hashes, e.g /wall instead of #/wall. However
    this also requires configuring the server to return index.html for 404 errors. For cloudfront this is done thru
    https://docs.aws.amazon.com/AmazonCloudFront/latest/DeveloperGuide/custom-error-pages-procedure.html

    More info:
    https://router.vuejs.org/guide/essentials/history-mode.html
     */
    mode: 'history',
    routes,
     scrollBehavior (to, from, savedPosition) {
       return { x: 0, y: 0 }
     }
});

/*router.afterEach((to, from) => {
   store.dispatch("pageLoaded", to);
});*/


new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');
